import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';

import MenuIcon from '@material-ui/icons/Menu';
import InfoIcon from '@material-ui/icons/Info';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import HomeIcon from '@material-ui/icons/Home';

import { IconButton } from "@material-ui/core";

import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom";



// const useStyles = makeStyles({
//     list: {
//         width: 250,
//     },
//     fullList: {
//         width: 'auto',
//     },
// });

// export default function Sidebar() {
//     const classes = useStyles();
//     const [state, setState] = React.useState({
//         left: false
//     });

//     const toggleDrawer = (anchor, open) => (event) => {
//         if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
//             return;
//         }

//         setState({ ...state, [anchor]: open });
//     };

//     const list = (anchor) => (
//         <div
//             className={clsx(classes.list, {
//                 [classes.fullList]: anchor === 'top' || anchor === 'bottom',
//             })}
//             role="presentation"
//             onClick={toggleDrawer(anchor, false)}
//             onKeyDown={toggleDrawer(anchor, false)}
//         >
//             <List>
//                 {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
//                 <ListItem button key={text}>
//                     <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
//                     <ListItemText primary={text} />
//                 </ListItem>
//                 ))}
//             </List>

//             <Divider />

//             <List>
//                 {['All mail', 'Trash', 'Spam'].map((text, index) => (
//                 <ListItem button key={text}>
//                     <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
//                     <ListItemText primary={text} />
//                 </ListItem>
//                 ))}
//             </List>
//         </div>
//     );

//     return (
//         <div>
//             {['left'].map((anchor) => (
//                 <React.Fragment key={anchor}>
//                     <Button onClick={toggleDrawer(anchor, true)}>
//                         {anchor}
//                     </Button>

//                     <Drawer 
//                         anchor={anchor} 
//                         open={state[anchor]} 
//                         onClose={toggleDrawer(anchor, false)}
//                     >
//                         {list(anchor)}
//                     </Drawer>
//                 </React.Fragment>
//             ))}
//         </div>
//     );
// }


export default class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };

        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    openDrawer = () => {
        this.setState({isOpen: true});
    }

    closeDrawer = () => {
        this.setState({isOpen: false});
    }

    toggleDrawer = () => {
        this.setState({isOpen: ![this.state.isOpen]});
    }

    render() {
        return(
            <div>
                <IconButton onClick={this.openDrawer}>
                    { !this.isOpen ? <MenuIcon style={{fontSize: 40, color: "#f0a742"}} /> : null }
                </IconButton>

                <Drawer 
                    variant="temporary" 
                    open={this.state.isOpen} 
                    handleClose={this.closeDrawer}
                    onClose={this.closeDrawer}
                    onToggleDrawer={this.toggleDrawer}
                >
                    <List style={{width: 250}}>
                        <Link to="/">
                            <ListItem button key="Home">
                                <ListItemIcon><HomeIcon /></ListItemIcon>
                                <ListItemText>Home</ListItemText>
                            </ListItem>
                        </Link>
                        
                        <Link to="/about">
                            <ListItem button key="About">
                                <ListItemIcon><InfoIcon /></ListItemIcon>
                                <ListItemText>About us</ListItemText>
                            </ListItem>
                        </Link>

                        {/* <Link to="/contact">
                            <ListItem button key="Contact">
                                <ListItemIcon><ContactPhoneIcon /></ListItemIcon>
                                <ListItemText>Contact</ListItemText>
                            </ListItem>
                        </Link> */}
                    </List>
                </Drawer>
            </div>
        );
    }
}
